var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4252 14.061C32.3943 16.0302 33.5005 18.701 33.5004 21.4859C33.5003 24.2707 32.3939 26.9414 30.4247 28.9105C28.4555 30.8796 25.7847 31.9858 22.9998 31.9857C20.215 31.9856 17.5443 30.8792 15.5752 28.91",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4848 13L30.4248 14.061",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5751 28.91L14.5151 29.971",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.985V34.985",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.985H29",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.124 18.485H17.75C18.1478 18.485 18.5294 18.643 18.8107 18.9243C19.092 19.2056 19.25 19.5872 19.25 19.985V21.614C19.2499 21.811 19.2887 22.0061 19.364 22.1882C19.4393 22.3702 19.5498 22.5356 19.689 22.675L20.844 23.83C21.0411 24.0269 21.1795 24.2748 21.2436 24.5459C21.3077 24.8171 21.295 25.1007 21.207 25.365L20.898 26.291C20.8014 26.5802 20.619 26.8331 20.375 27.016L19.159 27.928",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4001 14.379C24.9931 14.704 24.5591 15.041 24.1741 15.338C23.8616 15.5787 23.6565 15.9327 23.6031 16.3235C23.5498 16.7143 23.6525 17.1104 23.8891 17.426L24.8001 18.635C24.9398 18.8213 25.121 18.9725 25.3293 19.0766C25.5375 19.1808 25.7672 19.235 26.0001 19.235H26.8791C27.2768 19.2353 27.658 19.3936 27.9391 19.675L29.0941 20.83C29.2743 21.0101 29.4973 21.1413 29.7423 21.2113C29.9872 21.2812 30.246 21.2877 30.4941 21.23",
    stroke: "#072B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28.985C27.1421 28.985 30.5 25.6271 30.5 21.485C30.5 17.3428 27.1421 13.985 23 13.985C18.8579 13.985 15.5 17.3428 15.5 21.485C15.5 25.6271 18.8579 28.985 23 28.985Z",
    stroke: "#0397AB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomReset);
export default __webpack_public_path__ + "static/media/zoom_reset.ccdf297d5e5741aa1ac28cc4ef093432.svg";
export { ForwardRef as ReactComponent };